class LocalisationModal extends HTMLElement {
  constructor() {
    super();

    this.localisation = window.localisation;
    this.languageSelector = this.querySelector('#language-selector');
    this.countrySelector = this.querySelector('#country-selector');
    this.submit = this.querySelector('#submit-button');

    this.modalVisible = false;

    if (!window.localStorage.getItem('localisationPopup')) {
      window.localStorage.setItem('localisationPopup', 'true');
      this.classList.remove('tw-invisible');
    }
  }

  connectedCallback() {
    this.body = document.querySelector('body');

    const close = this.querySelectorAll('.close-button');

    close.forEach((item) => {
      item.addEventListener('click', this.close.bind(this));
    });

    let localisation = this.localisation.find(
      (country) => country.country == this.countrySelector.options[this.countrySelector.selectedIndex].dataset.country
    ).html;

    if (localisation) {
      this.languageSelector.classList.remove('tw-hidden');
      this.languageSelector.innerHTML = localisation;
    } else {
      this.languageSelector.classList.add('tw-hidden');
    }

    this.countrySelector.addEventListener('change', this.changeLanguage.bind(this));
    this.submit.addEventListener('click', this.onSubmit.bind(this));
  }

  open() {
    this.classList.remove('tw-invisible');
    this.classList.remove('tw-opacity-0');
    this.classList.add('tw-visible');
    this.classList.add('tw-opacity-100');
  }

  close() {
    this.classList.remove('tw-visible');
    this.classList.remove('tw-opacity-100');
    this.classList.add('tw-opacity-0');
    this.classList.add('tw-invisible');
  }

  changeLanguage() {
    let localisation = this.localisation.find(
      (country) => country.country == this.countrySelector.options[this.countrySelector.selectedIndex].dataset.country
    ).html;

    if (localisation) {
      this.languageSelector.classList.remove('tw-hidden');
      this.languageSelector.innerHTML = localisation;
    } else {
      this.languageSelector.classList.add('tw-hidden');
    }
  }

  onSubmit(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    if (form) form.submit();
  }
}

customElements.define('localisation-modal', LocalisationModal);

class LocalisationOpen extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', () => {
      document.querySelector('localisation-modal').open();
    });
  }
}

customElements.define('localisation-open', LocalisationOpen);
